import { FieldTypeEnum } from "@/core/enums/field-types";

const fields = {
  escopo: [
    {
      key: "id_projeto",
      name: `Código do projeto`,
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      rules: [{ rule: "required" }],
      labelBold: true,
      nao_comenta: true,
    },
    {
      key: "titulo",
      name: `Nome do Projeto`,
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "min", params: { size: 3 } }, { rule: "max", params: { size: 250 } }],
      counter: 250,
      maxLength: 250,
      nao_comenta: true,
    },
    {
      key: "titulo_transmissao",
      name: `Título do projeto de PD&I`,
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "min", params: { size: 3 } }, { rule: "max", params: { size: 150 } }],
      counter: 150,
      maxLength: 150,
      nao_comenta: true,
      ajudaComplexo: `
        <p>Informe o nome do projeto de Pesquisa, Desenvolvimento e Inovação (PD&I) submetido para a prestação de contas da Lei do Bem. O nome deve ser claro e representativo das atividades realizadas no projeto.</p>
        <p>Exemplos de nomes de projetos de Pesquisa, Desenvolvimento e Inovação (PD&I) adequados para submissão à Lei do Bem, segmentados por diferentes áreas:</p>
        <ol>
          <li>"Desenvolvimento de Plataforma de Inteligência Artificial para Diagnóstico Precoce de Doenças Respiratórias"</li>
          <li>"Sistema de Monitoramento Climático com Sensoriamento Remoto para Otimização da Produtividade Agrícola"</li>
          <li>"Criação de Middleware Seguro para Integração de Dispositivos IoT em Ambientes Industriais"</li>
          <li>"Desenvolvimento de Sistema de Previsão de Tráfego em Tempo Real com Aprendizado de Máquina"</li>
          <li>"Desenvolvimento de Anticorpo Monoclonal Humano para Tratamento de Doença Autoimune Rara"</li>
        </ol>
        <p>Esses títulos são claros, específicos e representativos das atividades de PD&I realizadas, facilitando a compreensão por parte dos avaliadores.</p>
      `
    },
    {
      key: "trabalho",
      name: "Benefício",
      type: FieldTypeEnum.SELECT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: { to: "trabalho", key: "id", name: "nome" },
    },
    {
      key: "status",
      name: "Status",
      type: FieldTypeEnum.SELECT,
      habilita_comentario: true,
      labelBold: true,
      rel: { to: "status", key: "id", name: "label" },
      colSize: 6,
    },
    {
      key: "ano_base",
      name: "Ano-base",
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      nao_comenta: true,
    },
  ],
  classificacao: [
    {
      key: "tipo_pesquisaId",
      name: `Categoria predominante`,
      type: FieldTypeEnum.SELECT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: { to: "tipoPesquisa", key: "id", name: "descricao" },
      ajudaComplexo: `
        <p>Classifique o projeto de Pesquisa, Desenvolvimento e Inovação (PD&I) de acordo com seu estágio, conforme definido pelo Decreto nº 5.798/2006, Art 2°. Selecione a categoria que melhor descreve as atividades desenvolvidas:</p>
        <ul>
          <li><b>a) pesquisa básica dirigida:</b> trabalhos executados para compreender novos fenômenos, com o objetivo de gerar conhecimento fundamental voltado ao desenvolvimento de produtos, processos ou sistemas inovadores.</li>
          <li><b>b) pesquisa aplicada:</b> trabalhos realizados para adquirir novos conhecimentos, visando o desenvolvimento ou aprimoramento de produtos, processos e sistemas.</li>
          <li><b>c) desenvolvimento experimental:</b> atividades sistemáticas baseadas em conhecimentos pré-existentes, destinadas a comprovar ou demonstrar a viabilidade técnica ou funcional de novos produtos, processos, sistemas e serviços, ou ao aprimoramento significativo dos já existentes.</li>
        </ul>
      `
    },
    {
      key: "tipo_trl",
      name: `Tipo TRL`,
      type: FieldTypeEnum.SELECT,
      habilita_comentario: true,
      labelBold: true,
      rules: [],
      rel: { to: 'tipoTrl', key: 'id', name: 'descricao' },
      ajudaComplexo: `
        <p>Selecione o tipo de TRL para filtrar os níveis de maturidade:</p>
        <ul>
          <li><b>Produtos:</b> Para desenvolvimento de produtos em geral.</li>
          <li><b>Processos:</b> Para desenvolvimento de processos produtivos (MRL).</li>
          <li><b>Software:</b> Para desenvolvimento de software (STRL).</li>
          <li><b>Fármacos:</b> Para desenvolvimento de fármacos e biofármacos.</li>
        </ul>
      `
    },
    {
      key: "nivel_trl_inicial",
      name: `Nível TRL inicial`,
      type: FieldTypeEnum.SELECT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: { to: "nivelTrl", key: "id", name: "descricao" },
      ajudaComplexo: `
        <p>Neste campo, selecione o nível de maturidade tecnológica do projeto, no início e no fim do ano-base, conforme os avanços obtidos. Utilize a classificação apropriada de acordo com o tipo de tecnologia:</p>
        <ul>
          <li><b>TRL – Technology Readiness Level (para produtos em geral)</b></li>
          <li><b>MRL – Manufacturing Readiness Level (para processos produtivos)</b></li>
          <li><b>STRL – Software Technology Readiness Level (para desenvolvimento de software)</b></li>
          <li><b>TRL aplicado a Fármacos e Biofármacos – para tecnologias na área farmacêutica e de biotecnologia</b></li>
        </ul>
        <p>Importante:</p>
        <ul>
          <li>- Se não houve mudança de estágio ao longo do ano-base, informe apenas o nível final.</li>
          <li>- Para facilitar o preenchimento, utilize as descrições abaixo como referência para identificar corretamente o estágio correspondente ao seu projeto.</li>
        </ul>
        <p>( ) TRL 1 / MRL 1 / STRL 1 / TRL 1 </p>
        <ul>
          <li>* Descrição geral para produtos: Princípios básicos observados e reportados: pesquisa exploratória para entender princípios fundamentais da tecnologia.</li>
          <li>* Descrição geral para processos (relativo à capacidade de produzir): Factível de ser produzido: descrição.</li>
          <li>* Descrição geral para software: Inicio da conceituação básica provendo o detalhamento da "formulação matemática".</li>
          <li>* Descrição geral para produtos (aplicado a fármacos e biofármacos): Foco em descoberta de novas moléculas. Os resultados da pesquisa científica são revisados e avaliados e a pesquisa aplicada tem início. Alvos potenciais e mecanismos de doenças são avaliados.</li>
        </ul>
        <p>( ) TRL 2 / MRL 2 / STRL 2 / TRL 2</p>
        <ul>
          <li>* Descrição geral para produtos: Formulação de conceitos tecnológicos e/ou de aplicação: identificação da aplicação prática de um conceito científico.</li>
          <li>* Descrição geral para processos (relativo à capacidade de produzir): Conceito de manufatura definido: descrição.</li>
          <li>* Descrição geral para software: "Algoritmos" ou funções básicas são prototipadas e documentadas.</li>
          <li>* Descrição geral para produtos (aplicado a fármacos e biofármacos): Hipóteses, ideias de pesquisa, protocolos e projetos experimentais são desenvolvidos. São identificados potenciais alvos terapêuticos para intervenção.</li>
        </ul>
        <p>( ) TRL 3 / MRL 3 / STRL 3 / TRL 3</p>
        <ul>
          <li>* Descrição geral para produtos: Estabelecimento de funçao crítica de forma analítica ou experimental e/ou prova de conceito: demonstração inicial da viabilidade da tecnologia em ambiente laboratorial.</li>
          <li>* Descrição geral para processos (relativo à capacidade de produzir): Processo de manufatura desenvolvido: prova de conceito para fazer funcionar.</li>
          <li>* Descrição geral para software: Algoritmos são executados e testados em processador representativo, em laboratório. "Protótipo"</li>
          <li>* Descrição geral para produtos (aplicado a fármacos e biofármacos): Teste das hipóteses e prova inicial de conceito (PoC) são demonstrados em um número limitado de modelos in vitro e in vivo para drogas candidatas.</li>
        </ul>
        <p>( ) TRL 4 / MRL 4 / STRL 4 / TRL 4</p>
        <ul>
          <li>* Descrição geral para produtos: Validação funcional em ambiente laboratorial: montagem e teste de componentes em condições controladas.</li>
          <li>* Descrição geral para processos (relativo à capacidade de produzir): Capacidade de produzir a tecnologia em ambiente laboratorial. Fazer funcionar apropriadamente.</li>
          <li>* Descrição geral para software: Componentes básicos do software são integrados para estabelecer trabalharão juntos. "Earliest version".</li>
          <li>* Descrição geral para produtos (aplicado a fármacos e biofármacos): Validação de drogas candidatas a partir de provas de conceito em modelos de laboratório.</li>
        </ul>
        <p>( ) TRL 5 / MRL 5 / STRL 5 / TRL 5</p>
        <ul>
          <li>* Descrição geral para produtos: Validação das funções críticas em ambiente relevante: testes em ambiente representativo do uso final da tecnologia.</li>
          <li>* Descrição geral para processos (relativo à capacidade de produzir): Capacidade de produzir protótipo do componente do produto em ambiente relevante de produção. Desenvolvimento Tecnológico para maximizar o desempenho.</li>
          <li>* Descrição geral para software: Todos os componentes do software são integrados em versão realística. O software é testado em ambiente controlado nas instalações do desenvolvedor. "Versão alfa".</li>
          <li>* Descrição geral para produtos (aplicado a fármacos e biofármacos): Realização de estudos pré-clínicos incluindo análises farmacológicas, farmacocinéticas e toxicológicas.</li>
        </ul>
        <p>( ) TRL 6 / MRL 6 / STRL 6 / TRL 6</p>
        <ul>
          <li>* Descrição geral para produtos: Demonstração das funções críticas em ambiente relevante: protótipo funcional próximo ao real testado em condições operacionais significativas.</li>
          <li>* Descrição geral para processos (relativo à capacidade de produzir): Capacidade de produzir o produto ou seus subconjuntos em ambiente relevante de produção. Demonstração tecnológica: a tecnologia está em fase de testes sem alcançar a escala final. O projeto não está finalizado, podendo utilizar uma gama limitada de modelos de simulação (dummies) e não alcançar o desempenho final. Busca maximizar a eficiência.</li>
          <li>* Descrição geral para software: Protótipo completo é testado em ambiente virtual ou simulado. O software ainda está em desenvolvimento. "Versão beta".</li>
          <li>* Descrição geral para produtos (aplicado a fármacos e biofármacos): Estudos clínicos Fase I asseguram a tolerância/segurança do medicamento, em um número restrito de voluntários sadios.</li>
        </ul>
        <p>( ) TRL 7 / MRL 7 / STRL 7 / TRL 7</p>
        <ul>
          <li>* Descrição geral para produtos: Demonstração das funções críticas em ambiente relevante: protótipo funcional próximo ao real testado em condições operacionais significativas.</li>
          <li>* Descrição geral para processos (relativo à capacidade de produzir): Capacidade de produzir o produto ou seus subconjuntos em ambiente relevante de produção. Demonstração tecnológica: a tecnologia está em fase de testes sem alcançar a escala final. O projeto não está finalizado, podendo utilizar uma gama limitada de modelos de simulação (dummies) e não alcançar o desempenho final. Busca maximizar a eficiência.</li>
          <li>* Descrição geral para software: Protótipo completo é testado em ambiente virtual ou simulado. O software ainda está em desenvolvimento. "Versão beta".</li>
          <li>* Descrição geral para produtos (aplicado a fármacos e biofármacos): Estudos clínicos Fase I asseguram a tolerância/segurança do medicamento, em um número restrito de voluntários sadios.</li>
        </ul>
        <p>( ) TRL 7 / MRL 7 / STRL 7 / TRL 7</p>
        <ul>
          <li>* Descrição geral para produtos: Demonstração em ambiente operacional: protótipo final testado em ambiente real.</li>
          <li>* Descrição geral para processos (relativo à capacidade de produzir): Capacidade de produzir o produto ou seus subconjuntos em ambiente representativo de produção. A tecnologia está em comissionamento inativo (cold). Isto pode incluir testes operacionais e testes de fabricação, mas é testado usando modelos ou simuladores inativos (dummies) compatíveis com o produto final.</li>
          <li>* Descrição geral para software: Verificação e validação são concluídas, a validade da solução é confirmada dentro do aplicativo pretendido. A especificação de requisitos é validada pelos usuários. O suporte de engenharia e organização de manutenção, incluindo o serviço de assistência técnica, estão em vigor. "Product release".</li>
          <li>* Descrição geral para produtos (aplicado a fármacos e biofármacos): Conclusão de Estudos Clínicos Fase 2 e procedimentos de registro de Estudos Clínicos Fase 3.</li>
        </ul>
        <p>( ) TRL 8 / MRL 8 / STRL 8 / TRL 8</p>
        <ul>
          <li>* Descrição geral para produtos: Sistema completo qualificado e finalizado: tecnologia finalizada e aprovada para uso comercial.</li>
          <li>* Descrição geral para processos (relativo à capacidade de produzir): Implementa a produção, minimizar custos. Tecnologia em comissionamento ativo (hot).</li>
          <li>* Descrição geral para software: Fim do desenvolvimento do sistema. Inclui teste e avaliação no sistema pretendido quanto às suas especificações. O resultado é versão de produção com configuração controlada. Documentação completa. "General product".</li>
          <li>* Descrição geral para produtos (aplicado a fármacos e biofármacos): Conclusão de Estudos Clínicos Fase 3 e procedimentos de registro na autoridade sanitária.</li>
        </ul>
        <p>( ) TRL 9 / MRL 9 / STRL 9 / TRL 9</p>
        <ul>
          <li>* Descrição geral para produtos: Sistema completo qualificado e finalizado: tecnologia finalizada e aprovada para uso comercial.</li>
          <li>* Descrição geral para processos (relativo à capacidade de produzir): Implementa a produção, minimizar custos. Tecnologia em comissionamento ativo (hot).</li>
          <li>* Descrição geral para software: Fim do desenvolvimento do sistema. Inclui teste e avaliação no sistema pretendido quanto às suas especificações. O resultado é versão de produção com configuração controlada. Documentação completa. "General product".</li>
          <li>* Descrição geral para produtos (aplicado a fármacos e biofármacos): Conclusão de Estudos Clínicos Fase 3 e procedimentos de registro na autoridade sanitária.</li>
        </ul>        
      `
    },
    {
      key: "nivel_trl_final",
      name: `Nível TRL final`,
      type: FieldTypeEnum.SELECT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: { to: "nivelTrl", key: "id", name: "descricao" },
    },
    {
      key: "justificativa_trl",
      name: `Justificativa TRL`,
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 1000 } }],
      counter: 1000,
      maxLength: 1000,
      ajudaComplexo: `
        <p>Explique os motivos que justificam a indicação do Nível de Maturidade Tecnológica inicial e final do seu projeto no ano-base.</p>
        <p>Considere os avanços alcançados e descreva as evidências técnicas que sustentam a classificação escolhida, como experimentos realizados, validações obtidas e testes executados. Explique os riscos e incertezas associados ao desenvolvimento e como eles estão sendo (ou foram) mitigados. Se possível, inclua referências a resultados, relatórios ou protótipos que demonstrem a evolução do projeto dentro das escalas de Maturidade Tecnológica.</p>
        <p>Se necessário, inclua um anexo detalhando sua explicação.</p>
      `
    },
    {
      key: "anexo_justificativa_trl",
      name: "Anexo Justificativa TRL",
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      nao_comenta: true,
      labelBold: true,
    },
    {
      key: "area_projeto",
      name: `Área do projeto`,
      type: FieldTypeEnum.SELECT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: { to: "areaProjeto", key: "id", name: "descricao" },
    },
    {
      key: "keyword_1",
      name: "Palavra-chave 1",
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "min", params: { size: 5 } }, { rule: "max", params: { size: 50 } }],
      counter: 50,
      maxLength: 50,
      ajudaComplexo: `
        <p>As palavras-chave auxiliam na categorização, análise e correta associação do projeto a especialistas da área. Evite termos genéricos e procure utilizar palavras que expressem claramente os diferenciais tecnológicos, setores de aplicação ou metodologias envolvidas.</p>
      `
    },
    {
      key: "keyword_2",
      name: "Palavra-chave 2",
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "min", params: { size: 5 } }, { rule: "max", params: { size: 50 } }],
      counter: 50,
      maxLength: 50,
    },
    {
      key: "keyword_3",
      name: "Palavra-chave 3",
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "min", params: { size: 5 } }, { rule: "max", params: { size: 50 } }],
      counter: 50,
      maxLength: 50,
    },
    {
      key: "keyword_4",
      name: "Palavra-chave 4",
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "min", params: { size: 5 } }, { rule: "max", params: { size: 50 } }],
      counter: 50,
      maxLength: 50,
    },
    {
      key: "keyword_5",
      name: "Palavra-chave 5",
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "min", params: { size: 5 } }, { rule: "max", params: { size: 50 } }],
      counter: 50,
      maxLength: 50,
    },
    {
      key: "naturezaId",
      name: `Natureza predominante do desenvolvimento`,
      type: FieldTypeEnum.SELECT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: { to: "natureza", key: "id", name: "descricao" },
      ajudaComplexo: `
      <p>Selecione a natureza do projeto conforme a inovação principal que ele promove:</p>
      <p>A inovação pode ser classificada em dois grandes tipos: inovação de produto e inovação de processo. A primeira refere-se a mudanças significativas nos bens ou serviços oferecidos por uma empresa, enquanto a segunda trata da introdução de novos ou aprimorados processos internos de negócios.</p>
      <ul>
        <li><b>( ) Inovação de Produto – Bens:</b> A inovação de produto ocorre quando uma empresa desenvolve ou melhora significativamente um bem, tornando-o diferente dos produtos anteriores e que tenham sido introduzidos no mercado. Bens incluem objetos tangíveis e alguns produtos baseados em conhecimento, cujos direitos de propriedade podem ser estabelecidos e transferidos por transações de mercado.</li>
        <li><b>( ) Inovação de Produto – Serviços:</b> Uma inovação de serviço ocorre quando há melhorias significativas na forma como ele é prestado, tornando-o mais eficiente, acessível ou conveniente para o usuário. Serviços são atividades intangíveis produzidas e consumidas simultaneamente, que alteram as condições dos usuários. A participação dos usuários é essencial para a coprodução dos serviços. Suas características podem depender da contribuição dos usuários e podem incluir alguns produtos baseados em conhecimento.</li>
        <li><b>( ) Inovação de Processos:</b> Refere-se à introdução de um processo novo ou aprimorado para uma ou mais funções empresariais que difere significativamente dos processos anteriores da empresa e que foi implementado na empresa.</li>
      </ul>
      <p>OBS: Caso o projeto envolva mais de um tipo de inovação, selecione aquele que melhor representa o foco principal do desenvolvimento.</p>

    `,
    },

  ],
  objetivos: [
    {
      key: "descricao",
      name: `Descrição do Projeto`,
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 3000 } }],
      counter: 3000,
      maxLength: 3000,
      ajudaComplexo: `
        <p>Descreva de forma clara e objetiva o projeto de Pesquisa, Desenvolvimento e Inovação (PD&I), incluindo:</p>
        <ol>
          <li><b>Classificação da pesquisa:</b> informe se o projeto se enquadra como Pesquisa Básica Dirigida, Pesquisa Aplicada ou Desenvolvimento Experimental;</li>
          <li><b>Etapas do Projeto:</b> identifique etapas estratégicas do projeto;</li>
          <li><b>Elementos tecnologicamente inovadores:</b> detalhe os avanços tecnológicos ou científicos que diferenciam o projeto em relação ao estado da arte;</li>
          <li><b>Caracterização como P&D:</b> explique como o projeto se qualifica como pesquisa e desenvolvimento, destacando a incerteza tecnológica envolvida, o desenvolvimento de novos conhecimentos ou a criação de soluções inovadoras;</li>
          <li><b>Marcos críticos:</b> identifique os principais desafios e obstáculos ao desenvolvimento do projeto;</li>
        </ol>

      `
    },
    {
      key: "desafio_tecnologico",
      name: "Barreiras ou desafios tecnológicos superáveis",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 1500 } }],
      counter: 1500,
      maxLength: 1500,
      ajudaComplexo: `
        <p>Descreva de forma clara e detalhada os obstáculos tecnológicos enfrentados durante o projeto de PD&I, bem como as estratégias adotadas para superá-los.</p>
        <p>Abaixo, seguem orientações para elaborar essa descrição de maneira alinhada aos critérios estabelecidos:</p>
        <ol>
          <li>Identifique o Problema Tecnológico (descreva o problema ou dificuldade tecnológica específica que o projeto buscou resolver; explique os impactos que essa barreira gerou no desenvolvimento do projeto, como atrasos, custos adicionais ou limitações técnicas.)</li>
          <li>Indique o Status de Superação (informe se a barreira tecnológica já foi superada ou se o projeto ainda está em desenvolvimento. Caso a barreira tenha sido superada, descreva os resultados alcançados e como eles impactam positivamente o projeto. Caso a barreira ainda não tenha sido superada, detalhe as hipóteses sendo testadas e as etapas futuras para resolver o problema. Caso a barreira ainda não tenha sido superada, descreva as etapas futuras e o cronograma previsto para a resolução do problema, assim como indique os recursos necessários (humanos, financeiros, tecnológicos) para concluir a superação.)</li>
          <li>Destaque a Relevância do Desafio (explique por que a superação dessa barreira é importante para o sucesso do projeto; relacione a superação do desafio com os objetivos gerais do projeto e os benefícios esperados).</li>
          <li>Inclua Dados e Evidências (utilize dados concretos para embasar a descrição, como métricas de desempenho, resultados de testes ou comparações com soluções existentes; inclua evidências científicas ou técnicas que comprovem a eficácia da abordagem adotada).</li>
        </ol>
        <p>OBS:</p>
        <ul>
          <li>Seja específico e evite generalidades;</li>
          <li>Utilize linguagem técnica, mas clara e acessível;</li>
          <li>Inclua dados quantitativos sempre que possível (por exemplo, porcentagens, métricas de desempenho);</li>
          <li>Relacione o projeto com os objetivos da Lei do Bem, destacando seu alinhamento com o avanço tecnológico e a inovação.</li>
        </ul>

      `
    },
    {
      key: "elemento_tecnologico",
      name: "Elemento tecnologicamente novo ou inovador",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 1500 } }],
      counter: 1500,
      maxLength: 1500,
      ajudaComplexo: `
        <p>Descreva de forma objetiva os aspectos que demonstram a inovação e o avanço tecnológico proposto no projeto.</p>
        <p>Abaixo, seguem orientações para elaborar essa descrição de forma clara e alinhada aos critérios estabelecidos:</p>
        <p><b>1.	Descreva a Tecnologia Desenvolvida:</b> explique de forma detalhada a tecnologia desenvolvida no projeto; destaque as novas funcionalidades ou características que a tornam diferente das soluções existentes; indique a aplicação prática da tecnologia, ou seja, em qual contexto ou setor ela será utilizada;</p>
        <p><b>2.	Evidencie as Novidades Tecnológicas:</b> explique por que a tecnologia proposta é nova ou inovadora em relação ao estado da arte atual; descreva os avanços científicos ou tecnológicos que o projeto busca alcançar; destaque se a solução envolve:</p>
        <ol>
          <li>a compreensão de novos fenômenos (Pesquisa Básica Dirigida);</li>
          <li>o desenvolvimento ou aprimoramento de produtos, processos ou sistemas (Pesquisa Aplicada);</li>
        </ol>
        <p><b>3.	Compare com as Soluções Existentes:</b> descreva as soluções atualmente disponíveis no mercado ou na literatura técnica; aponte as limitações dessas soluções que justificaram o desenvolvimento da nova tecnologia; explique como o projeto superou essas limitações.</p>
        <p><b>4.	Justifique o Desenvolvimento:</b> explique os motivos que levaram à necessidade de desenvolver a nova tecnologia; destaque os benefícios esperados, como aumento de eficiência, redução de custos, melhoria de desempenho ou impacto ambiental positivo; relacione o desenvolvimento com a superação de uma barreira tecnológica ou científica.</p>
        <p><b>5.	Destaque a Não Obviedade da Solução:</b> explique por que a solução proposta não é óbvia; destaque os aspectos criativos ou inovadores que diferenciam a proposta.</p>
        <p><b>OBS:</b></p>
        <ol>
          <li>Utilize linguagem clara e técnica, evitando jargões excessivos;</li>
          <li>Inclua dados quantitativos sempre que possível (por exemplo, porcentagens, métricas de desempenho);</li>
          <li>Relacione o projeto com os objetivos da Lei do Bem, destacando seu alinhamento com o avanço tecnológico e a inovação.</li>
        </ol>

      `
    },
    {
      key: "metodologia",
      name: "Descrição das etapas",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 1500 } }],
      counter: 1500,
      maxLength: 1500,
      ajudaComplexo: `
        Descrever de forma detalhada as técnicas, métodos e procedimentos utilizados para superar o desafio tecnológico e alcançar os objetivos do projeto de PD&I.
        <p>Abaixo, seguem orientações para elaborar essa descrição:</p>
        <p><b>Descreva as Atividades Realizadas</b> (detalhe as atividades específicas realizadas durante o projeto, como estudos bibliográficos, experimentos em laboratório, testes em bancada, desenvolvimento de protótipos, etc. Explique como essas atividades contribuíram para a superação do desafio tecnológico).</p>
        <p><b>Explique os Métodos e Técnicas Utilizados</b> (descreva os métodos científicos e técnicos aplicados no projeto, como análises estatísticas, modelagem computacional, ensaios físicos, etc.; destaque a cientificidade dos métodos, ou seja, como eles garantem a confiabilidade e a validade dos resultados)</p>
        <p><b>Detalhe os Processos de Desenvolvimento Experimental</b> (explique como foi conduzido o desenvolvimento experimental, desde a concepção da ideia até a validação da solução; inclua informações sobre os recursos e equipamentos utilizados, bem como as etapas de teste e validação).</p>
        <p><b>Demonstre as Competências Exigidas</b> (descreva as competências técnicas e científicas necessárias para implementar o projeto; mencione a qualificação da equipe e a colaboração com instituições de pesquisa, se aplicável).</p>
        <p><b>Explique como a Barreira/Desafio foi Superado</b> (descreva como os métodos e processos adotados contribuíram para a superação do desafio tecnológico; destaque os resultados alcançados e como eles representam uma melhoria em relação às soluções existentes.)</p>
        <p><b>Inclua Dados e Evidências</b> (utilize dados concretos para embasar a descrição, como métricas de desempenho, resultados de testes ou comparações com soluções existentes; inclua evidências científicas ou técnicas que comprovem a eficácia da abordagem adotada.)</p>
        <p><b>OBS:</b></p>
        <ol>
          <li>Caso o projeto ainda esteja em andamento, descreva as etapas futuras e os métodos que serão utilizados para concluir o desenvolvimento;</li>
          <li>Mencione os recursos necessários (humanos, financeiros, tecnológicos) para finalizar o projeto;</li>
          <li>Utilize uma linguagem técnica, mas clara e acessível;</li>
          <li>Evite generalidades e seja específico ao descrever métodos e processos;</li>
          <li>Relacione a descrição com os objetivos da Lei do Bem, destacando a inovação e o avanço tecnológico.</li>
        </ol>
      `
    },
  ],
  descricao: [
    {
      key: "atividade_continua",
      name: `Atividade é continua?`,
      type: FieldTypeEnum.RADIO,
      habilita_comentario: true,
      outline: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: {
        to: [
          {
            id: "1",
            descricao: "Sim"
          },
          {
            id: "2",
            descricao: "Não"
          }
        ],
        key: "id",
        name: "descricao"
      },
    },
    {
      key: "data_inicio",
      name: "Data de Início",
      type: FieldTypeEnum.DATE,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      nao_comenta: true,
      condition: (projeto) => !!projeto.atividade_continua,
    },
    {
      key: "data_fim",
      name: "Data/Previsão de Término",
      type: FieldTypeEnum.DATE,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      nao_comenta: true,
      condition: (projeto) => !!projeto.atividade_continua,
    },
    {
      key: "atividadeAnoBase",
      name: "Atividades de PD&I desenvolvidas no ano-base",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 3000 } }],
      counter: 3000,
      maxLength: 3000,
      condition: (projeto) => projeto.atividade_continua == 1,
      ajudaComplexo: `
      <p>Se o projeto for plurianual (ou seja, tiver duração superior a um ano), é necessário detalhar as atividades de Pesquisa, Desenvolvimento e Inovação (PD&I) realizadas especificamente no ano-base.</p>
      <p><b>OBS:</b></p>
      <ol>
        <li>Informe as principais ações executadas, avanços obtidos, desafios enfrentados e quaisquer alterações no planejamento original.</li>
        <li>Caso o projeto tenha sido iniciado em anos anteriores, destaque a continuidade das etapas e o progresso alcançado no período atual (ano-base avaliado).</li>
        <li>Se houver mudanças significativas no escopo ou nos desafios do projeto, utilize este campo para justificar essas alterações.</li>
      </ol>
      `
    },
    {
      key: "info_complementar",
      name: "Detalhamentos adicionais sobre as informações fornecidas",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 2000 } }],
      counter: 2000,
      maxLength: 2000,
      ajuda: 'Utilize este campo para fornecer detalhes adicionais (se necessários) que não foram contemplados nos campos anteriores. Você pode incluir esclarecimentos sobre aspectos técnicos do projeto, justificativas para escolhas metodológicas, desafios enfrentados, alterações no escopo ou quaisquer informações relevantes para a avaliação do projeto.'
    },
  ],
  resultados: [
    {
      key: "resultado_economico",
      name: "Resultado econômico",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 2000 } }],
      counter: 2000,
      maxLength: 2000,
      ajuda: `
        <p>Descreva de forma clara e objetiva o principal objetivo do projeto, destacando os resultados econômicos esperados/alcançados pela empresa. Informe como os resultados do projeto impacta(ra)m a competitividade da empresa no mercado nacional e internacional. Além disso, apresente as expectativas quanto ao impacto econômico, como aumento de receita, tempo estimado de retorno, redução de custos, ganho de competitividade, previsão de retorno econômico no mercado nos primeiros cinco anos, ou geração de novos mercados.</p>
        <p><b>OBS:<b> Caso haja métricas ou projeções financeiras, inclua-as para fortalecer a justificativa.</p>
      `
    },
    {
      key: "resultado_inovacao",
      name: "Resultado de inovação",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 2000 } }],
      counter: 2000,
      maxLength: 2000,
      ajudaComplexo: `
        <p>Descreva de forma clara e objetiva o principal resultado de inovação esperado inicialmente/obtido do projeto de PD&I. Especifique o produto, tecnologia ou processo desenvolvido e detalhe os avanços tecnológicos alcançados. Explique como o projeto contribui para a inovação, desenvolvimento tecnológico ou aprimoramento de processos. Explique como essa inovação melhora (ou melhorará) a empresa, seja por meio de aumento da competitividade, diferenciação no mercado, eficiência operacional ou novas oportunidades de negócio.</p>
        <p>Se houver impactos setoriais, destaque como a inovação beneficia a indústria ou segmento de atuação, incluindo possíveis mudanças no mercado, novas demandas ou efeitos sobre concorrentes e fornecedores.</p>
        <p>Além disso, indique possíveis impactos sociais e ambientais advindos dos resultados do projeto. Explique se a inovação contribui para geração de empregos, inclusão social, melhoria da qualidade de vida ou outras questões relevantes. No aspecto ambiental, informe se há ganhos relacionados à sustentabilidade, como redução de impacto ambiental (redução de emissões, economia de recursos naturais) ou melhor eficiência energética.</p>
        <p><b>OBS:</b> A resposta deve ser específica e inequívoca, evitando descrições genéricas.</p>
      `
    },
    {
      key: "ods_contemplados",
      name: "ODS contemplados",
      type: FieldTypeEnum.AUTOCOMPLETE_MULTIPLE,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: { to: "ods", key: "id", name: "descricao" }
    },
    {
      key: "justificativa_ods",
      name: "Justificativa de ODS contemplados",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 1000 } }],
      counter: 1000,
      maxLength: 1000,
      ajuda: `Justifique como o projeto contribui para cada ODS selecionado. A vinculação com os ODS deve ser objetiva e estar alinhada às metas específicas do projeto.`
    },
    {
      key: "alinhamento_politicas",
      name: "Alinhamento com políticas públicas / programas",
      type: FieldTypeEnum.RADIO,
      habilita_comentario: true,
      outline: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: {
        to: [
          {
            id: 1,
            descricao: "Sim"
          },
          {
            id: 2,
            descricao: "Não"
          }
        ],
        key: "id",
        name: "descricao"
      },
      ajuda: `Identifique qua(l)is política(s) pública(s) nacional(is) possui(em) relação com o projeto de PD&I. Explique de forma clara e objetiva como o projeto contribuiu para os objetivos dessas políticas. Destaque programas governamentais, estratégias setoriais ou marcos regulatórios que foram relevantes para o projeto. Mencione apenas políticas atuais (últimos 5 anos) e que ainda estejam em vigência ou tenham sido atualizadas recentemente.`
    },
    {
      key: "justificativa_alinhamento_politicas",
      name: "Justificativa de alinhamento com políticas / programas",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 1000 } }],
      counter: 1000,
      maxLength: 1000,
      condition: (projeto) => projeto.alinhamento_politicas == 1,
    },
    {
      key: "anexo_alinhamento_politicas",
      name: "Anexo Alinhamento Políticas",
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      nao_comenta: true,
    },
    {
      key: "desenvolvimento_empresas",
      name: "O projeto foi desenvolvido em cooperação com uma ou mais empresas?",
      type: FieldTypeEnum.RADIO,
      habilita_comentario: true,
      outline: true,
      labelBold: true,
      rules: [{ rule: "required" }],
      rel: {
        to: [
          {
            id: 1,
            descricao: "Sim"
          },
          {
            id: 2,
            descricao: "Não"
          }
        ],
        key: "id",
        name: "descricao"
      },
    },
    {
      key: "desenvolvimento_empresas_justificativa",
      name: "Preencha o CNPJ, razão social e anexo comprobatório",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "required" }, { rule: "max", params: { size: 3000 } }],
      counter: 3000,
      maxLength: 3000,
      condition: (projeto) => projeto.desenvolvimento_empresas == 1,
    },
    {
      key: "anexo_desenvolvimento_empresas",
      name: "Anexo Desenvolvimento Empresas",
      type: FieldTypeEnum.TEXT,
      habilita_comentario: true,
      nao_comenta: true,
    },
    // {
    //   key: "material_consumo",
    //   name: "Material de consumo",
    //   type: FieldTypeEnum.RICHTEXT,
    //   labelBold: true,
    //   rules: [{ rule: "required" }, { rule: "max", params: { size: 1500 } }],
    //   counter: 1500,
    //   maxLength: 1500,
    // },
    {
      key: "informacoes_complementares",
      name: "Dados adicionais (não obrigatório, utilizado apenas dentro do projeto para informações adicionais)",
      type: FieldTypeEnum.RICHTEXT,
      habilita_comentario: true,
      labelBold: true,
      rules: [{ rule: "max", params: { size: 150000 } }],
      counter: 150000,
      maxLength: 150000,
    },
  ]
};

export default fields;